import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@datagrupo2/dg-crud';
import { map, Observable } from 'rxjs';
import { replaceEdpointParams } from '../helpers/endpoints-helpers';
import { EVENTOS_CONFIG_ADMIN, PERMISSOES, PERMISSOES_EFETIVAS_USUARIO } from '../core/config/endpoints';
import { HttpService } from './http/http.service';
import { IPermissaoAdminEvento } from '../entitys/permissao-admin-evento';
import { IPagedResponse, RestObject } from '../helpers/http-helpers';
import { IConfiguracaoAdminEvento } from '../entitys/configuracao-admin-evento.entity';
import { IPermissaoEfetivaUsuario } from '../entitys/permissao-individual-evento';

@Injectable({
  providedIn: 'root'
})
export class PermissaoAdminEventoService {
  private dgHttp = inject(HttpService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {}

  getPermissoes(eventoId: string): Observable<IPermissaoAdminEvento[]> {
    return this.dgHttp.get(replaceEdpointParams(PERMISSOES, eventoId), {
      params: {
        page: '0',
        size: '1000'
      }
    }).pipe(
      map((response: any) => response?.content || [])
    );
  }

  getConfiguracaoAdmin(eventoId: string): Observable<IConfiguracaoAdminEvento> {
    return this.dgHttp.get(replaceEdpointParams(EVENTOS_CONFIG_ADMIN, eventoId)).pipe(map(response => response.data));
  }

  getPermissoesEfetivas(eventoId: string, usuarioId: string): Observable<IPermissaoEfetivaUsuario> {
    return this.dgHttp.get(
      replaceEdpointParams(PERMISSOES_EFETIVAS_USUARIO, { eventoId, usuarioId })
    ).pipe(map(response => response?.data ?? response));
  }

}
